<template>
  <router-view />

  <v-app class="rounded rounded-md">
    <!-- アプリバー -->
    <TopBar @toggle-drawer="drawer = !drawer" />
    <!-- メニュー -->
    <TopMenu v-model="drawer" />
    <!-- メイン -->
    <v-main class="align-center justify-center" style="min-height: 300px;">

      <!-- トップメニュー -->
      <v-container class="bg-red">
        <v-row>
          <v-text-field class="ma-2" density="compact" prepend-inner-icon="mdi-magnify" variant="solo-filled" flat
            hide-details v-model="keyword" @keyup.enter="search" @click:prepend-inner="search" placeholder="キーワードで検索"></v-text-field>
        </v-row>
        <v-row>
          <v-col><v-btn class="px-1 w-100" height="50px"
              to="/sportsstore"><v-icon>mdi-home</v-icon><span>スポーツ店</span></v-btn></v-col>
          <v-col><v-btn class="px-1 w-100"
              height="50px" to="/teamclubcircle"><v-icon>mdi-account-group</v-icon><span>サークル<br>チーム</span></v-btn></v-col>
          <v-col><v-btn class="px-1 w-100" height="50px"><v-icon>mdi-run</v-icon><span>スポーツ団体</span></v-btn></v-col>
        </v-row>
      </v-container>

      <!-- 新着店舗 -->
      <v-container class="">
        <v-row class="bg-red mt-2 px-2 py-1">
          スポーツ店
        </v-row>
        <v-row>
          <div class="px-2">新着スポーツ店</div>
        </v-row>
        <v-row class="scroll-x-content">
          <v-col v-for="item in sport_store" :key="item.sport_id" cols="12" xs="12" sm="6" md="6" lg="4" xl="3">
            <v-card :to="{ name: 'sportsstoredetail', params: {sportsStoreId: item.sports_store_id} }" hover ripple>
              
              <v-card class="mx-auto" max-width="100%">
                <v-carousel height="250" :show-arrows="false">
                  <v-carousel-item v-for="slide in item.sports_store_photo" :key="slide.record_id" :src="slide.path" cover  cycle hide-delimiter-background>
                  </v-carousel-item>
                </v-carousel>
              </v-card>

              <v-card-title class="flex-column align-start">
                <h3 class="text-h6">
                  {{ item.store_name }}
                </h3>
                <div class="text--primary">
                  {{ item.appeal_point }}
                </div>
              </v-card-title>
            </v-card>

          </v-col>
        </v-row>
        <v-row>
          <p>更新スポーツ店</p>
        </v-row>
      </v-container>

      <!-- チーム・サークル -->

    </v-main>
    <!-- フッター非表示化 -->
  </v-app>
</template>

<script>
// import Vue from 'vue'
import TopBar from '@/components/TopBar.vue'
import TopMenu from '@/components/TopMenu.vue'
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faShop } from  '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import axios from 'axios'

// export default {
//   data() {
//     return {
//       faShop
//     }
//   }
// }
// library.add(faShop)

// Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
  name: 'App',
  components: {
    TopBar,
    TopMenu,
  },
  data: () => ({
    drawer: false,
    reveal: false,
    authorize: false,
    user: null,
    sport_store: [],
    keyword: ''
  }),
  created: function () {
    this.getData()
    axios.get(
      process.env.VUE_APP_API_URL + '/api/logincheck',
      { headers: { "Authorization": JSON.stringify(this.$store.getters.getToken) } }
    ).then(response => {
      if (response.status == 200 && response.data.user) {
        this.user = response.data.user
        this.authorize = true
      } else {
        this.authorize = false
      }
    }).catch(() => {
      this.authorize = false
    })
  },
  methods: {
    getData() {
      axios.get(process.env.VUE_APP_API_URL + '/sportsstore/list?limit=6')
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.sport_store = response.data.sport_store
        })
    },
    search() {
      if (!this.keyword.trim()) {
        this.getData();
        return;
      }
      axios.post(process.env.VUE_APP_API_URL + '/sportsstore/search', { keyword: this.keyword })
        .then(response => {
          this.sport_store = response.data.sport_store
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
}
</script>